'use client'

import Link from 'next/link'
import { LuRotateCw } from 'react-icons/lu'

import { Button, buttonStyles } from '@/core/components/form/button/button'
import SafeImage from '@/features/veluvit/components/ui/media-image'

import type { Route } from 'next'
import type { ReactNode } from 'react'

/** 홈 전체가 비었을 때의 안내 — 그림(가장자리가 검정 바탕에 녹아든다) · 제목 · 한 줄 · 행동 하나 */
function HomeNotice({
  image,
  title,
  description,
  action,
  alert,
}: {
  image: string
  title: string
  description: string
  action: ReactNode
  alert?: boolean
}) {
  return (
    <section
      role={alert ? 'alert' : undefined}
      aria-label={title}
      className="flex animate-fade-in flex-col items-center px-6 pt-4 pb-16 text-center over10:pt-8 over10:pb-24"
    >
      <SafeImage
        src={image}
        alt=""
        width={640}
        height={640}
        sizes="(min-width: 1001px) 320px, 240px"
        preload
        appearance="plain"
        className="size-60 object-cover [mask-image:radial-gradient(closest-side,#000_62%,transparent)] over10:size-80"
      />
      <h2 className="-mt-2 text-c20 leading-[1.35] font-bold tracking-[-0.02em] text-balance text-t1 over10:text-c24">
        {title}
      </h2>
      <p className="mt-2 max-w-sm text-c14 leading-[1.6] text-pretty text-t3 over10:text-c15">
        {description}
      </p>
      <div className="mt-6">{action}</div>
    </section>
  )
}

export function HomeEmpty({ unit }: { unit: string }) {
  return (
    <HomeNotice
      image="/images/veluvit/empty-stage.webp"
      title={`아직 무대에 오른 ${unit}가 없어요`}
      description={`첫 ${unit}가 공개되면 여기서 가장 먼저 만날 수 있어요. 기다리는 동안 직접 만들어 볼까요?`}
      action={
        <Link
          href={'/studio-renew' as Route}
          className={buttonStyles({ bold: true, className: 'min-w-40' })}
        >
          작품 만들기
        </Link>
      }
    />
  )
}

export function HomeError({ onRetry }: { onRetry: () => void }) {
  return (
    <HomeNotice
      alert
      image="/images/veluvit/error-projector.webp"
      title="잠깐 상영이 멈췄어요"
      description="홈을 불러오지 못했어요. 연결을 확인하고 다시 불러와 주세요."
      action={
        <Button bold className="min-w-40" onClick={onRetry}>
          <LuRotateCw aria-hidden="true" className="size-4" />
          다시 불러오기
        </Button>
      }
    />
  )
}
